<template lang="pug">
#mainContent.col-12
  div(v-for="gr in CUSTOM_CATEGORIAS" :key="gr.id" )
    section(:id="`section${gr.id}`")
      .main-title
        h5 #[i.bi.bi-tag] {{ gr.nombre }}
    .row.menu-gallery
      .col-6.col-md-3.animated-element(v-for="(a, index) in gr.articulos" :key="index" :id="`gridItem${a.id}`")
        .item-body
          figure(@click="addToOrden(a)" style="cursor:pointer")
            img.img-fluid(v-if='a.imagen_base64' :src='`data:image/png;base64,${a.imagen_base64}`')
            img.img-fluid(v-else src='/img/plato-comida.jpg')
            .item-body-link
              .item-title
                h3 {{ a.descripcion_comercial }}
                small
          ul
            li
              span.item-price
                span {{ a.valor_sugerido_venta | formatNumber }}
            li: a.add-item-to-cart(href='javascript:void(0);' @click="addToOrden(a)"): i.bi.bi-cart-plus
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
    bodega: null
  }),

  created() {
    this.bodega = this.$route.params.bodega
  },

  computed: {
    ...mapState(['CATEGORIAS', 'ITEMS_MENU']),

    CUSTOM_CATEGORIAS() {
      let custom_categorias = []
      let filtroBase = (item, categoria) => item.grupo.id === categoria.id
      if (this.bodega) {
        filtroBase = (item, categoria) => item.grupo.id === categoria.id && item.bodega.id == this.bodega
      }
      custom_categorias = this.CATEGORIAS.map(categoria => {
        const filtro = item => filtroBase(item, categoria)
        categoria.articulos = this.ITEMS_MENU
          .filter(filtro)
          .map(item => item.articulo)

        return categoria
      })
      // return custom_categorias.filter(c => c.articulos.length)
      return custom_categorias
    }
  },

  methods: {
    addToOrden(art) {
      this.$store.commit('SET_ORDEN', { art, bodega: this.bodega })
    }
  }
}
</script>